import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButton as MuiToggleButton,
  styled,
} from '@mui/material'
import { alpha } from '@mui/material/styles'

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)({
  backgroundColor: 'transparent',
})

export const ToggleButton = styled(MuiToggleButton, {
  shouldForwardProp: prop => prop !== 'inverted',
})<{
  inverted?: boolean
}>(({ theme, inverted }) => ({
  color: inverted
    ? alpha(theme.palette.common.white, 0.75)
    : theme.icons?.toolbar || alpha(theme.palette.common.black, 0.54),
  borderColor: inverted ? alpha(theme.palette.common.black, 0.5) : 'transparent',
  border: inverted ? undefined : 0,
  borderRadius: inverted ? undefined : '50%',
  padding: theme.spacing(1),
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
  '@media (min-width: 1920px)': {
    padding: theme.spacing(1.25),
    '& .MuiSvgIcon-root': {
      fontSize: 18,
    },
  },

  '&:hover': {
    backgroundColor: inverted
      ? alpha(theme.palette.common.white, 0.08)
      : alpha(theme.palette.common.black, 0.04),
  },

  '&.Mui-selected': {
    color: inverted
      ? theme.palette.common.white
      : theme.icons?.toolbar || alpha(theme.palette.common.black, 0.54),
    backgroundColor: inverted ? theme.palette.grey[400] : theme.palette.primary.lighter,
    '&:hover': {
      backgroundColor: inverted ? theme.palette.grey[500] : theme.palette.primary.light,
    },
  },

  '&.Mui-disabled': {
    color: inverted
      ? alpha(theme.palette.common.white, 0.25)
      : alpha(theme.palette.common.black, 0.26),
    backgroundColor: 'transparent',
    borderColor: inverted
      ? alpha(theme.palette.common.white, 0.25)
      : alpha(theme.palette.common.black, 0.12),
    border: inverted ? undefined : 0,
  },

  ...(inverted
    ? {}
    : {
        '&.MuiToggleButtonGroup-grouped': {
          border: 0,
          borderRadius: '50%',
          margin: 0,
          '&:not(:first-of-type)': {
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%',
            borderLeft: 0,
            marginLeft: 0,
          },
          '&:not(:last-of-type)': {
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
          },
        },
      }),
}))
